export const EXPORT_REPORT_SETTINGS_TOOLTIPS = {
  template:
    'Choose a saved report template to preselect widgets and settings, or start with a blank report.',
  compare:
    'Add a time comparison to the report, such as the previous period or the same period last year.',
  reportName: 'Name shown on the exported report and used when saving or scheduling.',
  format: 'Choose the file format for the exported report.',
  formatPdf: 'Export a formatted visual report with charts and layout.',
  formatCsv: 'Export tabular data for spreadsheets and further analysis.',
  reportData:
    'Choose whether the report follows the current dashboard view or includes all data for the selected period.',
  reportDataCurrentView:
    "Use the dashboard's currently applied filters, date range, comparison settings, and widget states.",
  reportDataAllData:
    'Include all available data for the selected period, regardless of the current dashboard filters and widget states.',
  schedule: 'Set up automatic delivery of this report on a recurring schedule.',
  customize:
    'Choose charts, templates, and per-widget data scope for your report.',
}
